import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import React from 'react';
import {LinkProps as NavLinkProps, useLocation} from 'react-router-dom';

import {useMenuList} from 'presentation/components';
import {RefundEnum} from 'presentation/constants';
import Icon from 'presentation/icons';
import {useHandleNewAppointment} from 'presentation/pages';
import {useExitFlowModalStore} from 'presentation/pages/private/refund/pages/Request/store/useExitFlowModalStore';
import {useExitFlowSidebarRouteStore} from 'presentation/pages/private/refund/pages/Request/store/useExitFlowSidebarRouteStore';
import {translations} from 'presentation/translations-new';
import {MenuListType} from '../types';
import {StyledModalButton, StyledNavLink, StyledPaper} from './styles';

const {booking} = translations['pt-br'].others.sidebar;

const Link = React.forwardRef<HTMLAnchorElement, NavLinkProps>((itemProps, ref) => (
	<StyledNavLink ref={ref} {...itemProps} />
));

const ModalLink = React.forwardRef<HTMLDivElement>((itemProps, ref) => (
	<StyledModalButton ref={ref} {...itemProps} />
));

export function BottomNav() {
	const {handleNewAppointment} = useHandleNewAppointment();
	const setExitFlowModalState = useExitFlowModalStore(state => state.setOpen);
	const setExitFlowSidebarRouteState = useExitFlowSidebarRouteStore(state => state.setRoute);
	const {MENU_LIST} = useMenuList();
	const {pathname} = useLocation();
	const isRequestRefund = pathname === RefundEnum.REQUEST;

	function handleModalActionLink(item: MenuListType) {
		if (isRequestRefund) {
			setExitFlowModalState(true);
			if (item?.route) {
				setExitFlowSidebarRouteState(item.route);
			}
			return;
		}
		if (item.title === booking) {
			handleNewAppointment();
		}
	}

	return (
		<StyledPaper>
			<BottomNavigation showLabels>
				{MENU_LIST.map((item: MenuListType, index: number) => {
					const isFunctionAction = item?.title === booking || isRequestRefund;
					return (
						<BottomNavigationAction
							title={item.title}
							key={index}
							label={item.title}
							component={isFunctionAction ? ModalLink : Link}
							to={isFunctionAction ? undefined : item.route}
							icon={<Icon name={item.icon} />}
							onClick={
								isFunctionAction ? () => handleModalActionLink(item) : undefined
							}
							id={item?.id}
						/>
					);
				})}
			</BottomNavigation>
		</StyledPaper>
	);
}
